/*
 * Maison Faubourg Paris · Horaires d'expédition.
 * Une seule source pour la fiche produit, le bandeau du haut et le panier : on règle les horaires ici, ils changent partout.
 *
 * Tout est calculé en heure de Paris, pour chaque visiteur, quel que soit le fuseau de son appareil.
 * Chaque phrase est une promesse faite au client : à garder vraie.
 *
 *  - SHIP_DAYS   : jours où des colis partent (0 = dimanche, 1 = lundi ... 6 = samedi).
 *  - CLOSED_DAYS : jours sans expédition (jours fériés, congés), au format AAAA-MM-JJ.
 *  - RULES       : tranches horaires (de « from » inclus à « to » exclu).
 *      mode 'today' : le colis part aujourd'hui (si aujourd'hui est un jour d'expédition) ;
 *      mode 'next'  : le colis part le prochain jour d'expédition (demain, ou lundi si demain est fermé).
 *      parts : { t } = texte simple, { s } = texte en gras, { day: true } = « demain » / « lundi »...
 *      cart  : { title, sub } = version courte pour le panier ; « {day} » est remplacé par « demain » / « lundi »...
 */
(function () {
  if (window.mfShipSchedule) return;

  var SHIP_DAYS = [1, 2, 3, 4, 5, 6];
  var CLOSED_DAYS = ['2026-11-11', '2026-12-25', '2027-01-01'];
  var DAY_NAMES = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  // Une seule promesse : commande avant 22 h, expédiée le jour même ; à partir de 22 h, le prochain jour d'expédition.
  var RULES = [
    {
      from: 0, to: 22, mode: 'today',
      parts: [{ t: 'Commandé avant ' }, { s: '22 h' }, { t: ', expédié ' }, { s: 'le jour même' }],
      cart: { title: 'Commande avant 22 h', sub: 'expédiée le jour même' }
    },
    {
      from: 22, to: 24, mode: 'next',
      parts: [{ t: 'Commandé maintenant, expédié ' }, { day: true }],
      cart: { title: 'Commande maintenant', sub: 'expédiée {day}' }
    }
  ];

  function isShipDay(date) {
    return SHIP_DAYS.indexOf(date.getUTCDay()) !== -1 && CLOSED_DAYS.indexOf(date.toISOString().slice(0, 10)) === -1;
  }

  // Message courant : { parts: [{ t } | { s }], cart: { title, sub } }, ou null si l'heure de Paris est introuvable
  // (la ligne reste alors masquée plutôt que d'annoncer un horaire faux).
  function get() {
    var dateParts;
    try {
      dateParts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
    } catch (e) {
      return null;
    }
    var v = {};
    dateParts.forEach(function (p) { v[p.type] = p.value; });
    var today = new Date(Date.UTC(parseInt(v.year, 10), parseInt(v.month, 10) - 1, parseInt(v.day, 10)));
    var hour = parseInt(v.hour, 10);

    var tomorrow = new Date(today.getTime());
    tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    var next = new Date(today.getTime());
    var guard = 0;
    do {
      next.setUTCDate(next.getUTCDate() + 1);
      guard++;
    } while (!isShipDay(next) && guard < 14);
    var dayLabel = next.getTime() === tomorrow.getTime() ? 'demain' : DAY_NAMES[next.getUTCDay()];

    var rule = null;
    RULES.forEach(function (r) {
      if (hour >= r.from && hour < r.to) rule = r;
    });
    if (!rule) return null;

    // un jour sans expédition (dimanche, férié) : on annonce le prochain jour d'expédition
    if (rule.mode === 'today' && !isShipDay(today)) {
      return {
        parts: [{ t: 'Commandé maintenant, expédié ' }, { s: dayLabel }],
        cart: { title: 'Commande maintenant', sub: 'expédiée ' + dayLabel }
      };
    }

    return {
      parts: rule.parts.map(function (p) { return p.day ? { s: dayLabel } : p; }),
      cart: { title: rule.cart.title, sub: rule.cart.sub.replace('{day}', dayLabel) }
    };
  }

  // Écrit le message dans un élément (texte simple + passages en gras). Retourne false si l'heure est introuvable.
  function render(target, strongClass) {
    var message = get();
    if (!message) return false;
    target.textContent = '';
    message.parts.forEach(function (p) {
      if (p.t) {
        target.appendChild(document.createTextNode(p.t));
      } else {
        var strong = document.createElement('strong');
        if (strongClass) strong.className = strongClass;
        strong.textContent = p.s;
        target.appendChild(strong);
      }
    });
    return true;
  }

  window.mfShipSchedule = { get: get, render: render };
})();
